<!-- example year picker -->
<mat-form-field class="full-width" color="accent">
  <input matInput [matDatepicker]="dp" id={{id}} placeholder="{{placeholder}}" [formControl]="date">
  <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker #dp
                  startView="multi-year"
                  (yearSelected)="chosenYearHandler($event, dp)">
  </mat-datepicker>
</mat-form-field>   